import { LocalDate } from "@js-joda/core";

export const getCurrentMonthRange = () => {
	const currentDate = LocalDate.now();
	const currentYear = currentDate.year();
	const currentMonth = currentDate.monthValue();

	return [
		LocalDate.of(currentYear, currentMonth, 1),
		LocalDate.of(currentYear, currentMonth, 1).plusMonths(1).minusDays(1),
	];
};

export const getCurrentQuarterRange = (): [LocalDate, LocalDate] => {
	const now = LocalDate.now();
	const Y = now.year();
	const quarters = [
		[LocalDate.parse(`${Y}-01-01`), LocalDate.parse(`${Y}-03-31`)],
		[LocalDate.parse(`${Y}-04-01`), LocalDate.parse(`${Y}-06-30`)],
		[LocalDate.parse(`${Y}-07-01`), LocalDate.parse(`${Y}-09-30`)],
		[
			LocalDate.parse(`${Y}-10-01`),
			LocalDate.parse(`${Y + 1}-01-01`).minusDays(1), // Account for leap years
		],
	] as [LocalDate, LocalDate][];

	const current = quarters.find(([from, to]) => {
		return (
			(now.isAfter(from) || now.equals(from)) &&
			(now.isBefore(to) || now.equals(to))
		);
	});

	if (!current) {
		throw new Error("Invalid quarter");
	}

	return current;
};

export const getCurrentYearRange = () => {
	const currentDate = LocalDate.now();
	const currentYear = currentDate.year();

	return [LocalDate.of(currentYear, 1, 1), LocalDate.of(currentYear, 12, 31)];
};
